export default __webpack_public_path__ + "static/media/inProgress.930e5075.png";